import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ArtistService from '../../../services/artistService';
import trimEnd from 'lodash/trimEnd';
import * as imageUtils from '../../../utils/imageUtils';

const ResultItem = ({item, roleType}) => { 
    const getThumbnail = (imageUrl, roleType) => {
        const params = '?width=120&aspectw=1&quality=80&mode=crop';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    };
    return (
        <li className="result">
            <Link to={`/${item.Username}`}>
                <div className="imgbox">
                    <img src={getThumbnail(item.Thumbnail, item.RoleType)} alt={item.Name} />
                </div>
            </Link>
            <div className="info">
                <h2><Link to={`/${item.Username}`} className="transition">{item.Name}</Link></h2>
                <p className="loc">{item.Location}</p>
                {ArtistService.showGenre(roleType.type) ?                 
                    <p className="genres">
                        {item.Genres.map((genre) =>                        
                            <span key={genre} className="badge transition">{genre}</span>
                        )}
                    </p>
                    : null
                }
                {
                    ArtistService.showInstrument(roleType.type) ?
                    <p className="loc">{`${item.Instrument} - ${item.Expertise}`}</p>
                    : null
                }
                {
                    ArtistService.showCapacity(roleType.type) ?
                    <p className="loc">{`Capacity: ${item.Capacity.toLocaleString()}`}</p>
                    : null
                }
                {
                    item.Associations ?
                    <p className="loc">{`${roleType.type == 'Fan' ? 'Favourite Artists:' : 'Influences:'} ${item.Associations.sort().join(', ')}`}</p>
                    : null
                }
            </div>
            <div className="shares">
                <ul className="list-unstyled shares">
                    {
                        ArtistService.showRating(roleType.type) ?
                        <li>
                            <span id="rating" className="rating" title="Rating">{`${item.Rating}dB`}</span>
                        </li>
                        : null
                    }
                    {
                        ArtistService.showMusic(roleType.type) ?
                        <li className="soc">
                            <span className="soc-connects btn-socconn transition" title="Music">
                                <svg className="icon icon-tab transition">
                                    <use xlinkHref="#icn-music" />
                                </svg>
                                {item.MusicCount}
                            </span>
                        </li>
                        : null
                    }
                    {
                        ArtistService.showVideos(roleType.type) ?
                        <li className="soc">
                            <span className="soc-connects btn-socconn transition" title="Videos">
                                <svg className="icon icon-tab transition">
                                    <use xlinkHref="#icn-tv" />
                                </svg>
                                {item.VideoCount}
                            </span>
                        </li>
                        : null
                    }
                    <li className="soc hidden-xs">
                        <span className="soc-connects btn-socconn transition" title="Plugged In">
                            <svg className="icon icn-plug">
                                <use xlinkHref="#icn-plug"/>
                            </svg>
                            {item.PluggedIn}
                        </span>
                    </li>
                </ul>                
                {
                    item.Distance ?
                    <ul className="list-unstyled shares distance">
                        <li>
                            {item.Distance < 1 ?
                            <p>{`< 1 ${trimEnd(item.DistanceUnit, 's')}`}</p>
                             :
                            <p>{`${parseFloat(item.Distance.toFixed(1)).toString()} ${item.DistanceUnit}`}</p>
                            }
                        </li>
                    </ul>
                    : null
                }
            </div>
        </li>
    );
};

ResultItem.propTypes = {
    item: PropTypes.object.isRequired,
    roleType: PropTypes.object.isRequired
};

export default ResultItem;